import { M, C, EMPTY } from '../constants';
import { isString } from '../utilities/inspect';
export function renderPath(ns, formatter) {
    if (isString(ns)) {
        return ns;
    }
    let result = [];
    for (let i = 0; i < ns.length; i++) {
        const n = ns[i];
        result.push(M, formatter(n[0]), formatter(n[1]), C);
        let lastResult;
        for (let f = 2; f < n.length; f += 6) {
            const p0 = formatter(n[f]);
            const p1 = formatter(n[f + 1]);
            const p2 = formatter(n[f + 2]);
            const p3 = formatter(n[f + 3]);
            const dx = formatter(n[f + 4]);
            const dy = formatter(n[f + 5]);
            const isPoint = p0 == dx && p2 == dx && p1 == dy && p3 == dy;
            if (!isPoint || lastResult != (lastResult = ('' + p0 + p1 + p2 + p3 + dx + dy))) {
                result.push(p0, p1, p2, p3, dx, dy);
            }
        }
    }
    return result.join(EMPTY);
}
